export const SIDE_FILTER_OFFSET = 42 + 36;